module.exports = ".page-wrapper .page--has-toolbar {\n  padding-top: 50px; }\n\n.page-wrapper .page__top-bar {\n  height: 50px; }\n"